import { onCLS, onINP, onLCP, type Metric } from "web-vitals";
import type { Tracker } from "./tracker";

/** Web vitals (LCP, CLS, INP) como um evento por métrica (docs/SITE.md §9). */
export function trackWebVitals(tracker: Tracker, event = "site.web_vitals"): void {
  if (!tracker.enabled) return;
  const report = (m: Metric) =>
    tracker.track(event, {
      name: m.name,
      value: Math.round(m.name === "CLS" ? m.value * 1000 : m.value),
      rating: m.rating,
    });
  onLCP(report);
  onCLS(report);
  onINP(report);
}
